import type { FilterComposable } from '@autobid/ui/composables/carsList/useFilter'
import { provide } from 'vue'

export function provideFilterComposable(composable: () => ReturnType<FilterComposable>): void {
  provide('carsListFilterComposable', composable)
}
